import { render, staticRenderFns } from "./validPhoneCode.vue?vue&type=template&id=70ddbfc8&scoped=true"
import script from "./validPhoneCode.vue?vue&type=script&lang=js"
export * from "./validPhoneCode.vue?vue&type=script&lang=js"
import style0 from "./validPhoneCode.vue?vue&type=style&index=0&id=70ddbfc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ddbfc8",
  null
  
)

export default component.exports